import { colors } from "../theme";

export const getColor = (color) => colors[color] || color;

export const colorProp = ({ color }) =>
  color ? `color: ${getColor(color)}` : "";

export const bgColorProp = ({ bgColor }) =>
  bgColor ? `background-color: ${getColor(bgColor)}` : "";

export const fwProp = ({ bold }) => (!!bold ? "font-weight: 700" : "");

export const fsProp = ({ fontSize }) => `font-size: ${fontSize || "1rem"}`;

export const brProps = ({ borderRadius }) =>
  borderRadius ? `border-radius: ${borderRadius}` : "";
